module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bubbletextafteraction":"Tap the microphone button, to ask me a question.","isSpeaking":"Speaking","notSpeaking":"Tap To Talk","isListening":"Listening","isThinking":"Thinking"},"es":{"bubbletextafteraction":"Toca el botón del micrófono, para preguntarme algo.","isSpeaking":"Hablando","notSpeaking":"Toca para hablar","isListening":"Escuchando","isThinking":"Pensando"}}')
  delete Component.options._Ctor
}
